import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationDE from "./locales/de.json";
import translationEN from "./locales/en.json";
import translationFR from "./locales/fr.json";
import translationNL from "./locales/nl.json";
import translationIT from "./locales/it.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            de: {translation: translationDE},
            en: {translation: translationEN},
            fr: {translation: translationFR},
            nl: {translation: translationNL},
            it: {translation: translationIT}
        },
        fallbackLng: "de",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;